export var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});